import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { ResourceGroupRestService } from "@app/services/hal/resource-group-rest.service";
import { ResourceGroup } from "@app/models/rest/resource-group";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class ResourceGroupStore extends RealTimeDataStore<ResourceGroup> {
  constructor() {
    const resourceGroupRestService = inject(ResourceGroupRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(resourceGroupRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("ResourceGroup");
  }
}
